import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import SectorsSection from "./components/SectorsSection";
import PhilosophySection from "./components/PhilosophySection";
import CEESection from "./components/CEESection";
import PartnershipSection from "./components/PartnershipSection";
import ClientsSection from "./components/ClientsSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <SectorsSection />
        <PhilosophySection />
        <CEESection />
        <PartnershipSection />
        <ClientsSection />
        <ContactSection />
      </main>
      <Footer />

      {/* Sticky phone bar — mobile only */}
      <a
        href="tel:0175434346"
        className="md:hidden fixed bottom-4 left-4 right-4 z-50 flex items-center justify-between gap-3 bg-[#00a340] text-white px-5 py-3 rounded-2xl cursor-pointer"
        style={{ boxShadow: "0 4px 24px rgba(0,163,64,0.35)" }}
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
            <i className="ri-phone-fill text-sm text-white"></i>
          </div>
          <div>
            <div className="text-[10px] text-green-200 uppercase tracking-widest font-semibold leading-none mb-0.5">Appelez-nous</div>
            <div className="font-bold text-sm tracking-wide leading-none">01 75 43 43 46</div>
          </div>
        </div>
        <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
          <i className="ri-arrow-right-line text-sm text-white"></i>
        </div>
      </a>
    </div>
  );
}
